import { SiteConfig } from '@/types';

import { SEO } from '../../nextSeo.config';

export const siteConfig: SiteConfig = {
  name: SEO.title,
  description: SEO.description,
  url: SEO.canonical,
  ogImage: SEO.openGraph.image,
  links: {
    twitter: SEO.twitter.site,
    github: SEO.github.site
  }
};
